import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Button, Typography } from "@mui/material";
import React from "react";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";

const GetStartedMenu = ({ text, link, isMP, handleNavigate }) => {
  return (
    <Button
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        padding: "16px 0",
        textTransform: "none",
      }}
      onClick={() => {
        dataLayerGTM("click_tag", "Click", "Link", `Get Started ${text}`);
        isMP
          ? handleNavigate()
          : link &&
            window.my.navigateTo({
              url: "/pages/link/link?url=" + encodeURIComponent(link),
            });
      }}
    >
      <Typography
        color="textPrimary"
        sx={{
          fontFamily: "FSElliotPro",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: 1.5,
        }}
      >
        {text}
      </Typography>
      <KeyboardArrowDownOutlinedIcon color="primary" sx={{ fontSize: 24 }} />
    </Button>
  );
};

export default GetStartedMenu;
